import { Box, Text, UnorderedList, ListItem, Image } from '@chakra-ui/react';
import grayCheckCircleSrc from '../../../assets/images/check-circle-gray.svg';
import checkCircleSrc from '../../../assets/images/check-circle.svg';

const PlanCardFeatures = ({ heading, features, isMuted = false }) => (
  <Box w="full">
    <Box borderTop="0.5px solid" borderColor="lightGrey" pt="10px" mb={3}>
      <Text textStyle="bodySmall" fontWeight="medium">
        {heading}:
      </Text>
    </Box>
    <UnorderedList spacing={3} ml={0} mb={3} w="full">
      {features.map((feature) => (
        <ListItem key={feature} display="flex" alignItems="center" gap={2}>
          <Image
            src={isMuted ? grayCheckCircleSrc : checkCircleSrc}
            alt="check"
            w="20px"
            h="20px"
          />
          <Text textStyle="headingFamilyMedium" fontSize="14px" color="#101828">
            {feature}
          </Text>
        </ListItem>
      ))}
    </UnorderedList>
  </Box>
);

export default PlanCardFeatures;
